import { useState, useCallback } from "react";

export const useCart = () => {
  const [cart, setCart] = useState([]);
  const [cost, setCost] = useState({
    subTotal: 0,
    tax: 0,
    total: 0,
  });

  const addTotals = useCallback((passedCart) => {
    let tempCart = [...passedCart];
    let subTotal = 0;
    tempCart.map((item) => (subTotal += item.total));
    let tax = 0.05 * subTotal;
    tax = parseFloat(tax.toFixed(2));
    let total = tax + subTotal;
    setCost({
      subTotal,
      tax,
      total,
    });
  }, []);

  const addToCart = useCallback(
    (item) => {
      let tempCart = [...cart];
      item.inCart = true;
      tempCart.push(item);
      setCart(tempCart);
      addTotals(tempCart);
    },
    [cart, addTotals]
  );

  const removeFromCart = useCallback(
    (id) => {
      let tempCart = [...cart];
      const selectedProduct = tempCart.find((item) => item.id === id);
      tempCart = tempCart.filter((tempItem) => tempItem.id !== id);
      selectedProduct.inCart = false;
      setCart(tempCart);
      addTotals(tempCart);
    },
    [cart, addTotals]
  );

  const clearCart = useCallback(() => {
    setCart([]);
    addTotals([]);
  }, [addTotals]);

  const increment = useCallback(
    (id) => {
      let tempCart = [...cart];
      const selectedProduct = tempCart.find((item) => item.id === id);
      selectedProduct.quantity += 1;
      selectedProduct.total = selectedProduct.quantity * selectedProduct.price;
      setCart([...tempCart]);
      addTotals(tempCart);
    },
    [cart, addTotals]
  );

  const decrement = useCallback(
    (id) => {
      let tempCart = [...cart];
      const selectedProduct = tempCart.find((item) => item.id === id);
      if (selectedProduct.quantity === 1) {
        removeFromCart(id);
      } else {
        selectedProduct.quantity -= 1;
        selectedProduct.total =
          selectedProduct.quantity * selectedProduct.price;
        setCart([...tempCart]);
        addTotals(tempCart);
      }
    },
    [cart, addTotals, removeFromCart]
  );
  return {
    cart,
    cost,
    addToCart,
    removeFromCart,
    clearCart,
    increment,
    decrement,
  };
};
